import { AssistantSmartTipsEntity, GxGuestAiSmartTipsEntity } from '@mews-commander/data-access';
import { useAssistantSmartTipsQuery } from './useAssistantSmartTipsQuery';
import { useGuestAiSmartTipsQuery } from './useGuestAiSmartTipsQuery';

/**
 * Fetches guest smart tips with configurable API support during migration (Assistant → GX AI)
 */
export const useSmartTipsQuery = (guestId: string, useAssistantApi: boolean, queryEnabled: boolean) => {
    const assistantQuery = useAssistantSmartTipsQuery(
        { id: guestId, entity: AssistantSmartTipsEntity.Customer },
        queryEnabled && useAssistantApi
    );

    const guestQuery = useGuestAiSmartTipsQuery(
        { id: guestId, entity: GxGuestAiSmartTipsEntity.Customer },
        queryEnabled && !useAssistantApi
    );

    return useAssistantApi ? assistantQuery : guestQuery;
};
